@use '~@frontrow/console/css/variables.scss';

.importRow {
  display: flex;
  margin-top: variables.$std-margin-xlg;
  margin-bottom: variables.$std-margin-xlg;
}

.title {
  font-size: variables.$font-size-md;
  text-transform: capitalize;
}

.rowDescription {
  width: 500px;
}

.uploadedCheck {
  width: 20px;
  height: 20px;
  margin: variables.$std-margin-md;
  color: #4bcfbe;
}
